import { calculateSerpWidth, MAX_TITLE_PX, MAX_DESCRIPTION_PX } from '../lib/seoHelper'

export const PAGE_META = {
  home: {
    title: 'Anlægsentreprenør i Hjortshøj | JT Knudsen',
    description: 'Lokal anlægsentreprenør i Hjortshøj. JT Knudsen udfører belægning, fundament, gravearbejde og nedgravning af trampolin i Aarhus og Østjylland.'
  },
  services: {
    title: 'Ydelser & anlægsarbejde | JT Knudsen Hjortshøj',
    description: 'Se vores ydelser inden for belægning, fundament, maskingravning og nedgravning af trampolin. JT Knudsen leverer professionelt arbejde i Østjylland.'
  },
  belaegning: {
    title: 'Belægning & terrasser i Hjortshøj | JT Knudsen',
    description: 'Professionel flisebelægning til have, terrasse og indkørsel. JT Knudsen sikrer stabilt bærelag, fald og flot finish i Hjortshøj, Aarhus og Østjylland.'
  },
  fundament: {
    title: 'Fundament & sokkel i Hjortshøj | JT Knudsen',
    description: 'Opbygning og støbning af fundament og sokkel til tilbygning, garage og skur. JT Knudsen sikrer præcis udgravning og solidt håndværk i Østjylland.'
  },
  gravearbejde: {
    title: 'Gravearbejde med minigraver | JT Knudsen Hjortshøj',
    description: 'Professionelt gravearbejde og maskingravning med moderne minigraver. Udgravning, planering og kabelrender i Hjortshøj, Aarhus og på Djursland.'
  },
  trampolin: {
    title: 'Nedgravning af trampolin | JT Knudsen Hjortshøj',
    description: 'Professionel nedgravning af trampolin tilpasset haven. JT Knudsen sikrer korrekt dybde, dræn og plan overgang i Hjortshøj, Aarhus og Østjylland.'
  },
  about: {
    title: 'Om Jonas Knudsen | Entreprenør JT Knudsen',
    description: 'Mød Jonas Knudsen fra JT Knudsen i Hjortshøj. Personlig kontakt, solidt håndværk og moderne maskiner til anlægs- og gravearbejde i Østjylland.'
  },
  gallery: {
    title: 'Galleri & projekter | JT Knudsen Hjortshøj',
    description: 'Se billeder af udført belægning, støbning af fundament, gravearbejde og nedgravning af trampoliner fra JT Knudsen i Hjortshøj og Østjylland.'
  },
  contact: {
    title: 'Kontakt Jonas Knudsen | JT Knudsen Hjortshøj',
    description: 'Kontakt JT Knudsen på tlf. 42 79 63 01 for et uforpligtende tilbud på belægning, fundament, gravearbejde eller nedgravning af trampolin i Østjylland.'
  },
  notFound: {
    title: '404 - Siden blev ikke fundet | JT Knudsen',
    description: 'Siden findes ikke. Vend tilbage til forsiden eller se JT Knudsens ydelser inden for haveanlæg, belægning og gravearbejde i Østjylland.'
  },
  forbidden: {
    title: '403 - Adgang nægtet | JT Knudsen',
    description: 'Adgang nægtet. Du har ikke tilladelse til denne side. Vend tilbage til forsiden for information om JT Knudsens anlægsydelser i Hjortshøj.'
  }
}

// Runtime validation verification (logged in dev if anything exceeds boundaries)
if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'production') {
  Object.entries(PAGE_META).forEach(([key, meta]) => {
    const tWidth = calculateSerpWidth(meta.title, 20)
    const dWidth = calculateSerpWidth(meta.description, 14)
    if (tWidth > MAX_TITLE_PX) {
      console.warn(`[SEO Warning] ${key} title (${tWidth}px) exceeds ${MAX_TITLE_PX}px: "${meta.title}"`)
    }
    if (dWidth > MAX_DESCRIPTION_PX) {
      console.warn(`[SEO Warning] ${key} description (${dWidth}px) exceeds ${MAX_DESCRIPTION_PX}px: "${meta.description}"`)
    }
  })
}
